<template>
  <div id="app">
    <ok-header v-if="!$isPc && $route.path !== '/install' "></ok-header>
    <router-view />
    <ok-footer v-if="$mode == 1 && !$isPc && $route.path !== '/install'"></ok-footer>
  </div>
</template>

<script>
import okHeader from './components/ok-header'
import okFooter from './components/ok-footer'

export default {
  components: {
    okHeader,
    okFooter
  }
}
</script>
